// React Imports
import React from 'react';
// Style
import 'components/list/tasks/tasks_row.style.scss';
// Assets
import { SERVICE } from 'assets/images/images.js';

class TasksRow extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      taskIndex: this.props.taskIndex,
      taskValue: this.props.taskValue,
    }
  }

  detailStatus(completed) {
    const { hasTaskCompleted } = this.props;

    if (!hasTaskCompleted) {
      return;
    }

    if (!completed) {
      return <div className='tasks-row-status ms-3'></div>;
    }
    return <img className='tasks-row-status ms-3' src={SERVICE.checkmark} alt="" />;
  }

  renderDiscount(discount) {
    if (!discount) { return; }
    return (
        <div className="tasks-row-text discount me-2"> -{discount}% </div>
    );
  }

  renderPrice(value) {
    if (!value) {
      return;
    }
    return `${value} €`;
  }

  render() {
    const { taskIndex, taskValue: { designation, price, completed, discount } } = this.state;
    // Right area auto-sizes to its content; parent list will align columns by setting a shared min-width.
    // Format designation: drop '1 x ' prefix, or compact 'number x ' to 'numberx '
    let displayDesignation = designation;
    if (typeof designation === 'string') {
      const trimmed = designation.trim();
      if (trimmed.startsWith('1 x ')) {
        displayDesignation = trimmed.slice(4);
      } else {
        // Match quantity (digits with optional separators), 'x', then the rest
        const m = trimmed.match(/^(\d[\d.,]*)\s*x\s+(.*)$/i);
        if (m) {
          const qtyStr = m[1];
          const rest = m[2];
          // Parse a normalized copy ONLY for comparison (display keeps original dots/commas)
          const qtyValueForCompare = parseFloat(qtyStr.replace(/\./g, '').replace(',', '.'));
          if (!Number.isNaN(qtyValueForCompare) && Math.abs(qtyValueForCompare - 1) < 1e-9) {
            displayDesignation = rest;
          } else {
            // Compact 'number x ' -> 'numberx '
            displayDesignation = `${qtyStr.replace(/\s+/g, '')}x ${rest}`;
          }
        }
      }
    }
    


    return (
      <li key={taskIndex} className='tasks-row-container py-2'>
        <div className={`tasks-row-text tasks-row-left text-align-left flex-start`} >{displayDesignation}</div>
        <div className={`tasks-row-text tasks-row-right d-flex align-items-center justify-content-end`}>
          {this.renderDiscount(discount)}
          {this.renderPrice(price)}
          {this.detailStatus(completed)}
        </div>
      </li>
    );
  }
}

export default TasksRow;
